import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';
import { useBlocker } from '@mint/routing';

export type Props = {
  shouldBlockFn: () => boolean;
};

export const LeavePageModal: FC<Props> = ({ shouldBlockFn }) => {
  const { t } = useTranslation('@myn/approval_v2');

  const { proceed, reset, status } = useBlocker({
    shouldBlockFn,
    withResolver: true,
    enableBeforeUnload: shouldBlockFn,
  });

  return (
    <Dialog modal open={status === 'blocked'}>
      <DialogOverlay />
      <DialogRoot size="s" aria-describedby={undefined}>
        <DialogHeader onClose={reset}>
          <WarningAltFilled className="mr-2 fill-warning-main" />
          <DialogTitle>{t('Unsaved changes')}</DialogTitle>
        </DialogHeader>
        <DialogContent>
          {t('You have unsaved changes. Leaving this page will discard them')}
        </DialogContent>

        <DialogFooter>
          <Button
            size="large"
            variant="text"
            onClick={reset}
            aria-label="Close leaving modal"
            data-dd-action-name="Close the modal"
          >
            {t('Cancel')}
          </Button>
          <Button
            size="large"
            aria-label="Leave page"
            data-dd-action-name="Leave the page"
            onClick={proceed}
            color="warning"
          >
            {t('Yes, leave page')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};
